import { useCallback, useRef } from 'react';

/**
 * 用于计算媒体交互指标的自定义Hook，包括停留时间和完播次数
 * @param delay 停留时间阈值
 * @param callback 回调函数，接收停留时间和完播次数
 * @returns 用于绑定到元素的事件处理函数和计数器控制函数
 */
export const useMediaMetrics = ({
  delay = 0,
  callback,
}: {
  /** 停留时间阈值 */
  delay?: number;
  /** 回调函数 */
  callback: (detailStayTime: number, completeTimes: number) => void;
}) => {
  const stayTimeRef = useRef<number | null>(null);

  const completeTimes = useRef<number>(0);

  const incrementCompleteTimes = useCallback(() => {
    completeTimes.current++;
  }, []);

  const handleEnter = useCallback(() => {
    stayTimeRef.current = Date.now();
  }, []);

  const handleLeave = useCallback(() => {
    if (stayTimeRef.current !== null) {
      const detailStayTime = Date.now() - stayTimeRef.current;
      if (detailStayTime > delay) {
        callback(detailStayTime, completeTimes.current);

        // 重置计数器
        completeTimes.current = 0;
      }
      stayTimeRef.current = null;
    }
  }, [callback, delay]);

  return {
    /** 进入事件 */
    handleEnter,
    /** 离开事件 */
    handleLeave,

    /** 增加完播次数 */
    incrementCompleteTimes,
  };
};
